"use client";

import { useQuery } from "@tanstack/react-query";
import { reviewKeys } from "@/features/reviews/shared/keys";
import type { ReviewFilters, ReviewsPagination } from "@/features/reviews/shared/types";

export function useReviews(filters: ReviewFilters) {
  return useQuery({
    queryKey: reviewKeys.list(filters),
    queryFn: async (): Promise<ReviewsPagination> => {
      const params = new URLSearchParams();
      params.set("productId", filters.productId);
      params.set("limit", String(filters.limit || 10));
      params.set("page", String(filters.page || 1));

      const response = await fetch(`/api/reviews?${params.toString()}`);

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.code || "FAILED_TO_LOAD_REVIEWS");
      }

      return response.json();
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
